import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import RouteSeo from "./RouteSeo";
import TransitionBanner from "./TransitionBanner";
import TransitionPopup from "./TransitionPopup";
import AnalyticsTracker from "./AnalyticsTracker";
import ConsentNotice from "./ConsentNotice";

export default function Layout() {
    const [bannerVisible, setBannerVisible] = useState(true);

    useEffect(() => {
        const setVar = () => {
            const el = document.querySelector('[data-testid="transition-notice"]');
            const h = bannerVisible && el ? el.offsetHeight : 0;
            document.documentElement.style.setProperty("--banner-h", `${h}px`);
        };
        setVar();
        const t = setTimeout(setVar, 50);
        window.addEventListener("resize", setVar);
        return () => {
            clearTimeout(t);
            window.removeEventListener("resize", setVar);
        };
    }, [bannerVisible]);

    return (
        <div className="App relative min-h-screen">
            <RouteSeo />
            <div className="grain-overlay" aria-hidden="true" />
            {bannerVisible && (
                <TransitionBanner onDismiss={() => setBannerVisible(false)} />
            )}
            <Navbar bannerVisible={bannerVisible} />
            <main id="main-content">
                <Outlet />
            </main>
            <Footer />
            <TransitionPopup />
            <AnalyticsTracker />
            <ConsentNotice />
        </div>
    );
}
